import { Button } from '@/components/ui/Button'
import './tour-tooltip.css'

interface TourTooltipProps {
	title: string
	content: string
	stepNumber: number
	totalSteps: number
	onNext: () => void
	onBack: () => void
	onSkip: () => void
}

export function TourTooltip({ title, content, stepNumber, totalSteps, onNext, onBack, onSkip }: TourTooltipProps) {
	const isFirstStep = stepNumber === 1
	const isLastStep = stepNumber === totalSteps

	return (
		<div className="tour-tooltip" data-testid="tour-tooltip">
			<div className="tour-tooltip__header">
				<h3 className="tour-tooltip__title">{title}</h3>
			</div>
			<p className="tour-tooltip__content">{content}</p>
			<div className="tour-tooltip__footer">
				<span className="tour-tooltip__step-indicator">
					{stepNumber} of {totalSteps}
				</span>
				<div className="tour-tooltip__actions">
					<Button variant="ghost" size="sm" onClick={onSkip}>
						Skip
					</Button>
					{!isFirstStep && (
						<Button variant="outline" size="sm" onClick={onBack}>
							Back
						</Button>
					)}
					<Button variant="action" size="sm" onClick={onNext}>
						{isLastStep ? 'Finish' : 'Next'}
					</Button>
				</div>
			</div>
		</div>
	)
}
